
import ReactList, { ReactListProvider } from "@7span/react-list";
import { useContext, createContext, useMemo, useEffect } from "react";
import { eventBus } from "utils/eventBus";

const TimesheetContext = createContext(null);

export const useTimesheet = () => {
  const context = useContext(TimesheetContext);

  if (!context) {
    throw new Error("useTimesheet must be used within a TimesheetProvider");
  }

  return context;
};

// Generic provider that accepts the hook to use
export const TimesheetProvider = ({
  children,
  requestHandler,
  endpoint = "timesheet",
  filters,
  date,
}) => {
  return (
    <ReactListProvider config={{ requestHandler }}>
      <ReactList filters={filters} meta={{ date }} endpoint={endpoint} version="4">
        {({ loader: { isLoading, initialLoading }, refresh, ...rest }) => {
          useEffect(() => {
            const handleRefresh = (id) => {
              if (id === `${endpoint}-${date}`) {
                refresh();
              }
            };

            eventBus.on("refresh", handleRefresh);

            return () => {
              eventBus.off("refresh", handleRefresh);
            };
          }, [refresh, date]);
          return useMemo(() => {
            return (
              <TimesheetContext.Provider
                value={{ date, isLoading, initialLoading, refresh, ...rest }}
              >
                {children}
              </TimesheetContext.Provider>
            );
          }, [isLoading, date, filters, initialLoading]);
        }}
      </ReactList>
    </ReactListProvider>
  );
};
